import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { MEALS_EQUIVALENT_SETUP_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { MealsEquivalentForm } from './components/MealEquivalentSetupForm';
import { getFiscalYears } from './state/siteequivalent/actions';
import * as Selector from './state/siteequivalent/selectors';
import { MealEquivalentSetupEnum as Fields } from 'Common/FieldEnum';
import { EquivalentSiteGrid } from './components/EquivalentSiteGrid';
import { TitledCard } from 'Components/';
import {
  checkAll,
  checkItem,
  writeChangesToSite,
  getGridData,
  clearError,
  setSaveSuccessful,
} from './state/siteequivalent/actions';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';

class MealEquivalentSetupContainer extends Component {
  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: MEALS_EQUIVALENT_SETUP_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getFiscalYears();
  }

  componentDidUpdate(prevProps) {
    const {
      fiscalYears,
      saveSuccessful,
      getGridData,
      gridData,
      change,
      selectedFiscalYear,
    } = this.props;

    if (
      fiscalYears &&
      prevProps.fiscalYears &&
      fiscalYears.length > 0 &&
      prevProps.fiscalYears.length !== fiscalYears.length
    ) {
      getGridData(fiscalYears[0]);
    }

    //update our textboxes with the proper value
    //if check a single row use those values
    //if multiple rows reset fields to zeros
    if (
      Array.isArray(gridData) &&
      gridData.filter(x => x.Selected).length !==
        prevProps.gridData.filter(x => x.Selected).length
    ) {
      const selectedValues = gridData.filter(x => x.Selected);
      let newValues = {
        [Fields.BreakfastToLunch]: '0.00',
        [Fields.SnackToLunch]: '0.00',
        [Fields.SupplementalToLunch]: '0.00',
      };
      if (selectedValues.length === 1) {
        newValues[Fields.BreakfastToLunch] =
          selectedValues[0][Fields.BreakfastToLunch];
        newValues[Fields.SnackToLunch] = selectedValues[0][Fields.SnackToLunch];
        newValues[Fields.SupplementalToLunch] =
          selectedValues[0][Fields.SupplementalToLunch];
      }
      change(
        MEALS_EQUIVALENT_SETUP_FORM_NAME,
        Fields.BreakfastToLunch,
        newValues[Fields.BreakfastToLunch]
      );
      change(
        MEALS_EQUIVALENT_SETUP_FORM_NAME,
        Fields.SnackToLunch,
        newValues[Fields.SnackToLunch]
      );
      change(
        MEALS_EQUIVALENT_SETUP_FORM_NAME,
        Fields.SupplementalToLunch,
        newValues[Fields.SupplementalToLunch]
      );
    }

    if (
      prevProps.saveSuccessful !== saveSuccessful &&
      saveSuccessful === true
    ) {
      createToast(toastType.success, 'Success', 'Saved Successfully');
      this.props.setSaveSuccessful(false);
      getGridData(selectedFiscalYear);
      this.props.checkAll(false);
    }

    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearError();
    }
  }

  handleSubmit = values => {
    const { gridData, writeChangesToSite } = this.props;

    const selectedSites = gridData
      .filter(row => row.Selected)
      .map(selected => selected.SiteId);
    const siteData = { ...values, SiteIdList: selectedSites };

    if (selectedSites.length) {
      writeChangesToSite(siteData);
    }
    if (!selectedSites.length) {
      createToast(toastType.error, 'Error', 'Please select at least one site.');
    }
  };

  render() {
    const {
      loading,
      gridData,
      checkAll,
      checkItem,
      isAllChecked,
      selectedFiscalYear,
    } = this.props;
    if (loading) {
      return <LoadingPage message={'Loading'} />;
    }

    return (
      <Fragment>
        <Filter title={'Meal Equivalent Setup'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Edit Meal Equivalents'}>
            <MealsEquivalentForm
              onSubmit={this.handleSubmit}
              fiscalYears={this.props.fiscalYears}
              gridData={this.props.gridData}
              getGridData={this.props.getGridData}
              isFieldDisabled={!gridData.some(row => row.Selected)}
              initialValues={{
                [Fields.FiscalYear]: selectedFiscalYear,
                [Fields.BreakfastToLunch]: '0.00',
                [Fields.SnackToLunch]: '0.00',
                [Fields.SupplementalToLunch]: '0.00',
              }}
            />
          </TitledCard>
          <TitledCard title={'Select Site to Apply Meal Equivalent'}>
            <EquivalentSiteGrid
              gridData={gridData}
              checkAll={checkAll}
              checkItem={checkItem}
              isAllChecked={isAllChecked}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: Selector.getLoading(state),
    fiscalYears: Selector.getFiscalYears(state),
    gridData: Selector.getGridData(state),
    isAllChecked: Selector.getIsAllChecked(state),
    saveSuccessful: Selector.getSaveSuccessful(state),
    selectedFiscalYear: Selector.getSelectedFiscalYear(state),
    error: Selector.getError(state),
  };
};

const mapDispatchToProps = {
  getFiscalYears,
  checkAll,
  checkItem,
  writeChangesToSite,
  getGridData,
  clearError,
  setSaveSuccessful,
  change,
};

export const MealEquivalentSetup = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MealEquivalentSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/MealEquivalentSetup.js